enum TRACKING_EVENTS {
  APPOINTMENT_REQUEST_PAGE = 'Appointment Request Page',
  APPOINTMENT_REQUEST_PAGE_CLIENT_FOUND = 'Appointment Request Page Client Found',
  APPOINTMENT_REQUEST_SUBMITTED = 'Appointment Request Submitted',
  REFILL_REQUEST_PAGE = 'Refill Request Page',
  REFILL_REQUEST_PAGE_CLIENT_FOUND = 'Refill Request Page Client Found',
  REFILL_REQUEST_SUBMITTED = 'Refill Request Submitted',
  PATIENT_INFORMATION_PAGE = 'Pet Information Page',
  NOTIFICATION_SETTINGS_PAGE = 'Notification Settings Page',
  ADDITIONAL_INFORMATION_PAGE = 'Additonal Information Page'
}

export default TRACKING_EVENTS;
